// extracted by mini-css-extract-plugin
export var button = "page-preview-module--button--64f76";
export var buttonText = "page-preview-module--buttonText--8c04a Button-module--filledDark--da7b8 Button-module--buttonBase--a1a0f";
export var excerpt = "page-preview-module--excerpt--5683e";
export var itemBlock = "page-preview-module--itemBlock--ed339";
export var root = "page-preview-module--root--7d56c";
export var title = "page-preview-module--title--dad20 typography-module--title3--c0886";